export const SETTINGS_SHELL_STYLE_TEXT = `
.kg-settings-root {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  background: var(--kg-settings-surface-1, var(--ds-surface-default, Canvas));
  border-color: var(--kg-settings-border, ButtonBorder);
  box-shadow: var(--kg-settings-shadow-card, var(--ds-shadow-soft, none));
  color: var(--kg-settings-text, CanvasText);
}
.kg-settings-root.kg-settings-shell-panel,
.kg-settings-root .kg-settings-shell-panel {
  flex: 1;
  width: 100%;
  min-height: 0;
  background: var(--kg-settings-surface-1, var(--ds-surface-default, Canvas)) !important;
  border-color: var(--kg-settings-border, ButtonBorder) !important;
  box-shadow: var(--kg-settings-shadow-card, var(--ds-shadow-soft, none)) !important;
}
.kg-settings-root.kg-settings-shell-panel > .ds-panel__header,
.kg-settings-root.kg-settings-shell-panel > .ds-panel__footer,
.kg-settings-root .kg-settings-shell-panel > .ds-panel__header,
.kg-settings-root .kg-settings-shell-panel > .ds-panel__footer,
.kg-settings-root .kg-settings-table-panel > .ds-panel__header,
.kg-settings-root .kg-settings-table-panel > .ds-panel__footer,
.kg-settings-root .kg-settings-notice > .ds-alert__header,
.kg-settings-root .kg-settings-notice > .ds-alert__footer {
  display: none;
}
.kg-settings-root.kg-settings-shell-panel,
.kg-settings-root .kg-settings-shell-panel {
  align-items: stretch;
}
.kg-settings-root.kg-settings-shell-panel > .ds-panel__body,
.kg-settings-root .kg-settings-shell-panel > .ds-panel__body {
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background: transparent !important;
}
.kg-settings-shell-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: transparent;
}
.kg-settings-root[data-ds-layout="plugin-page-panel"] .ds-plugin-page-panel__content-region {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
}
.kg-settings-root[data-ds-layout="plugin-page-panel"] .ds-plugin-page-panel__content-region > .ds-settings-shell-body {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
}

.kg-settings-root[data-ds-layout="plugin-page-panel"] .ds-plugin-page-panel__header {
  width: 100%;
}

.kg-settings-root[data-ds-layout="plugin-page-panel"] > .ds-panel__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}
.kg-settings-pack-meta {
  margin-top: 6px;
  font-size: var(--ui-font-size-12, 12px);
  line-height: 1.4;
  color: var(--kg-settings-text-subtle, GrayText);
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] {
  background: var(--kg-settings-surface-1, var(--ds-surface-default, Canvas)) !important;
  border-color: var(--kg-settings-border, ButtonBorder) !important;
  box-shadow: var(--kg-settings-shadow-3, var(--kg-settings-shadow-card, none)) !important;
  color: var(--kg-settings-text, CanvasText) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-modal__body,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-modal__footer {
  background: transparent !important;
  color: inherit !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-modal__title,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-modal__description,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-modal__body {
  color: var(--kg-settings-text, CanvasText) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert {
  background: var(--kg-settings-surface-2, var(--ds-surface-subtle, Canvas)) !important;
  border-color: var(--kg-settings-border, ButtonBorder) !important;
  box-shadow: var(--kg-settings-shadow-1, var(--kg-settings-shadow-card, none)) !important;
  color: var(--kg-settings-text, CanvasText) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert__body,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert__footer {
  background: transparent !important;
  color: inherit !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert__label,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert__body,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert__action {
  color: var(--kg-settings-text, CanvasText) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-success {
  background: color-mix(in srgb, var(--kg-settings-pill-positive-bg, var(--kg-settings-surface-2, Canvas)) 78%, var(--kg-settings-surface-1, Canvas)) !important;
  border-color: var(--kg-settings-pill-positive-border, var(--kg-settings-border, ButtonBorder)) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-success .ds-alert__label,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-success .ds-alert__body,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-success .ds-alert__action {
  color: var(--kg-settings-pill-positive-text, var(--kg-settings-text, CanvasText)) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-info {
  background: color-mix(in srgb, var(--kg-settings-pill-default-bg, var(--kg-settings-surface-2, Canvas)) 72%, var(--kg-settings-surface-1, Canvas)) !important;
  border-color: var(--kg-settings-pill-default-border, var(--kg-settings-border, ButtonBorder)) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-warning {
  background: color-mix(in srgb, var(--kg-settings-pill-warning-bg, var(--kg-settings-surface-2, Canvas)) 76%, var(--kg-settings-surface-1, Canvas)) !important;
  border-color: var(--kg-settings-pill-warning-border, var(--kg-settings-border, ButtonBorder)) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-warning .ds-alert__label,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-warning .ds-alert__body,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-warning .ds-alert__action {
  color: var(--kg-settings-pill-warning-text, var(--kg-settings-text, CanvasText)) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-error {
  background: color-mix(in srgb, var(--kg-settings-pill-danger-bg, var(--kg-settings-surface-2, Canvas)) 76%, var(--kg-settings-surface-1, Canvas)) !important;
  border-color: var(--kg-settings-pill-danger-border, var(--kg-settings-border, ButtonBorder)) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-error .ds-alert__label,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-error .ds-alert__body,
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-alert--intent-error .ds-alert__action {
  color: var(--kg-settings-pill-danger-text, var(--kg-settings-text, CanvasText)) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-button {
  background: var(--kg-settings-control-surface, ButtonFace) !important;
  border-color: var(--kg-settings-control-border, ButtonBorder) !important;
  box-shadow: var(--kg-settings-shadow-control-idle, none) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-button .ds-button__label {
  color: var(--kg-settings-control-text, ButtonText) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-button--intent-primary {
  background: var(--kg-settings-primary, Highlight) !important;
  border-color: var(--kg-settings-primary, Highlight) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-button--intent-primary .ds-button__label {
  color: var(--kg-settings-primary-text, HighlightText) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-button--intent-danger {
  background: var(--kg-settings-danger, Highlight) !important;
  border-color: var(--kg-settings-danger, Highlight) !important;
}
.kg-settings-themed-modal[data-kg-settings-theme-mode] .ds-button--intent-danger .ds-button__label {
  color: var(--kg-settings-danger-text, HighlightText) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-modal[data-ds-component="ds/modal"] {
  background: var(--kg-settings-modal-surface, var(--kg-settings-surface-1, Canvas)) !important;
  border-color: var(--kg-settings-modal-border, var(--kg-settings-border, ButtonBorder)) !important;
  box-shadow: var(--kg-settings-shadow-3, var(--kg-settings-shadow-card, none)) !important;
  color: var(--kg-settings-modal-text, var(--kg-settings-text, CanvasText)) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-modal__title,
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-modal__description,
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-modal__body {
  color: var(--kg-settings-modal-text, var(--kg-settings-text, CanvasText)) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-button {
  background: var(--kg-settings-control-surface, ButtonFace) !important;
  border-color: var(--kg-settings-control-border, ButtonBorder) !important;
  box-shadow: var(--kg-settings-shadow-control, none) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-button .ds-button__label {
  color: var(--kg-settings-control-text, ButtonText) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-button--intent-primary {
  background: var(--kg-settings-primary, Highlight) !important;
  border-color: var(--kg-settings-primary, Highlight) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-button--intent-primary .ds-button__label {
  color: var(--kg-settings-primary-text, HighlightText) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-button--intent-danger {
  background: var(--kg-settings-danger, Highlight) !important;
  border-color: var(--kg-settings-danger, Highlight) !important;
}
.kg-settings-modal-backdrop[data-kg-settings-theme-mode] .ds-button--intent-danger .ds-button__label {
  color: var(--kg-settings-danger-text, HighlightText) !important;
}
.kg-settings-shell-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.kg-settings-shell-brand {
  display: flex;
  align-items: center;
  gap: 16px;
}
.kg-settings-shell-logo {
  width: 56px;
  height: 56px;
  border-radius: var(--ui-radius-999, 999px);
  display: grid;
  place-items: center;
  font-size: clamp(18px, 1.5vw, 24px);
  font-weight: 800;
  letter-spacing: 0.08em;
  color: var(--ui-text-on-brand, CanvasText);
  background: linear-gradient(135deg, var(--kg-settings-brand-start, var(--ds-accent-surface, Canvas)), var(--kg-settings-brand-end, var(--ds-accent-border, Canvas)));
  box-shadow: var(--kg-settings-brand-shadow, var(--ds-shadow-soft, none));
}
.kg-settings-shell-title {
  margin: 0;
  font-size: clamp(34px, 3vw, 48px);
  line-height: 1.1;
  color: var(--kg-settings-text, CanvasText);
  letter-spacing: -0.03em;
}
.kg-settings-shell-sub {
  margin: 8px 0 0;
  font-size: var(--ui-font-size-14, 14px);
  line-height: 1.5;
  color: var(--kg-settings-text-subtle, GrayText);
}
`;
